import { FormSelectField, Typography } from 'omakase';
import { QuestionOptionalTextField } from 'forms/previsit-questions/QuestionOptionalTextField';
import { QuestionSelectResponse } from '@tock/shared/utils/questionUtils';
import { core } from '@tock/coretypes';
import { getOptionsFromQuestion } from 'forms/previsit-questions/questionOptions';
import { useField } from 'formik';

interface Props {
  name: string;
  question: core.TicketTypeQuestion;
}

export const QuestionSelectField = ({ name, question }: Props) => {
  const [, { value }] = useField<QuestionSelectResponse>(name);
  const options = getOptionsFromQuestion(question);
  return (
    <div data-testid="pre-visit-question">
      <Typography variant="body02" data-testid="pre-visit-question-label">
        {question.text}
      </Typography>
      <FormSelectField
        name={`${name}.value`}
        inputProps={{ 'data-testid': 'pre-visit-question-select', 'aria-label': question.text }}
      >
        <option></option>
        {options.map((option) => (
          <option value={option.text || ''} key={option.text}>
            {option.text}
          </option>
        ))}
      </FormSelectField>
      <QuestionOptionalTextField name={name} question={question} value={value.value} />
    </div>
  );
};
